// icons
import { MdAttachMoney, MdCheckCircle, MdPending } from "react-icons/md";

const comisiones = {
  id: 'comisiones-group',
  type: 'group',
  roles: [1, 200],
  breadcrumbs: false,
  children: [
    {
      id: 'comisiones',
      title: "Comisiones",
      type: 'collapse',
      icon: MdAttachMoney,
      children: [
        {
          id: 'pendientes-pago',
          title: "Pendientes de Pago",
          type: 'item',
          breadcrumbs: false,
          icon: MdPending,
          url: '/comisiones/pendientes-pago'
        },
        {
          id: 'pagadas',
          title: "Pagadas",
          type: 'item',
          breadcrumbs: false,
          icon: MdCheckCircle,
          url: '/comisiones/pagadas'
        }
      ]
    }
  ]
};

export default comisiones;
